import { ContextService } from '../../services/context_service';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RechteService } from '../../services/rechte_service';
import { Routing } from '../../helpers/Routing';
import { RoutingIDs } from '../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { TriggerService } from '../trigger/trigger_service';
import { WRechteGroup } from './WRechteGroup';
import { WRechteMain } from './WRechteMain';
import { WRechteUser } from './WRechteUser';
import { WRechteZugang } from './WRechteZugang';


interface WRechteProps extends React.ClassAttributes<any> {
    modul: string;
    costumClass?: string;
    formLayout?: string;
    customUserTable?: boolean;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface WRechteState {
    tabIndex: number;
    rechteBasis: any;
    stamp: number;
}

export class WRechte extends React.Component<WRechteProps, WRechteState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null,
            rechteBasis: {},
            stamp: 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(RechteService) private rechteService: RechteService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private disabled: string[] = [];
    private modul: string = 'legacy';
    private prefix: string = 'system.internal';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_RECHTEVERWALTUNG;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_RECHTEVERWALTUNG_BENUTZER },
        { path: RoutingIDs.ROUTE_RECHTEVERWALTUNG_RECHTE },
        { path: RoutingIDs.ROUTE_RECHTEVERWALTUNG_GRUPPEN }
    ];
    private tabs: string[] = ['rechte', 'rechte', 'rechte']; // Reitereihenfolge beachten


    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setRechteBasis();
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }
        const { costumClass, formLayout } = this.props;

        return (
            <Tabs
                className='tabs-admin-rechteverwaltung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.rechte}>Benutzer</Tab>
                    <Tab disabled={!this.rechte.rechte}>Rechte</Tab>
                    <Tab disabled={!this.rechte.rechte}>Gruppen</Tab>
                    <Tab disabled={true}>Eigener Zugang</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.rechte &&
                        <WRechteUser
                            modul={this.modul}
                            stamp={this.state.stamp}
                            rechteBasis={this.state.rechteBasis}
                            onDataChange={() => this.setRechteBasis()}
                            costumClass={costumClass}
                            formLayout={formLayout}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.rechte &&
                        <WRechteMain
                            modul={this.modul}
                            stamp={this.state.stamp}
                            rechteBasis={this.state.rechteBasis}
                            onDataChange={() => this.setRechteBasis()}
                            costumClass={costumClass}
                            formLayout={formLayout}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.rechte &&
                        <WRechteGroup
                            modul={this.modul}
                            stamp={this.state.stamp}
                            rechteBasis={this.state.rechteBasis}
                            onDataChange={() => this.setRechteBasis()}
                            costumClass={costumClass}
                            formLayout={formLayout}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {false &&
                        <WRechteZugang
                            modul={this.modul}
                            stamp={this.state.stamp}
                            rechteBasis={this.state.rechteBasis}
                            onDataChange={() => this.setRechteBasis()}
                            costumClass={costumClass}
                            formLayout={formLayout}
                        />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setRechteBasis(): void {
        this.rechteService.getRechteBasis(this.modul, (rechteBasis: any) => {
            console.log(rechteBasis);
            this.triggerService.fire('reload', 'RECHTE');
            const stamp = new Date().getTime();
            this.setState({ rechteBasis, stamp });
        });
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
